import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetBlogList, EResetBlogListActionType } from './types';

export const resetBlogList: () => TResetBlogList = actionGenerator<EResetBlogListActionType.Reset>(
  EResetBlogListActionType.Reset,
);
